// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"fadd8bd3","173":"24c37f95","215":"1a3f1ca1","239":"dfd83733","456":"df3a6d1a","489":"07859f4c","909":"d8cceb1e","926":"66750483"}[chunkId] + ".chunk.js";
};